(function () {
  var stickyBar = document.getElementById('sticky-atc');
  if (!stickyBar) return;

  var mainAtcForm = document.querySelector('product-form form[data-type="add-to-cart-form"]');
  var mainButton = mainAtcForm ? mainAtcForm.querySelector('button[name="add"]') : null;

  var stickyButton = document.getElementById('sticky-atc-button');
  var stickyVariantInput = document.getElementById('sticky-atc-variant');
  var stickyPriceEl = stickyBar.querySelector('.sticky-atc__price');
  var stickyButtonText = stickyButton ? stickyButton.querySelector('.sticky-atc__button-text') : null;

  // --- Show/hide sticky bar based on real ATC button's visibility ---
  if (mainButton) {
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        stickyBar.classList.toggle('is-visible', !entry.isIntersecting);
      });
    }, { rootMargin: '0px' });

    observer.observe(mainButton);
  }

  // --- Keep sticky bar synced with Dawn's variant change event ---
  document.addEventListener('variant:change', function (e) {
    if (!e.detail || !e.detail.variant) return;
    var variant = e.detail.variant;

    if (stickyVariantInput) {
      stickyVariantInput.value = variant.id;
    }

    if (stickyPriceEl && variant.price) {
      var moneyFormat = (window.theme && window.theme.moneyFormat) ? window.theme.moneyFormat : '${{amount}}';
      stickyPriceEl.textContent = Shopify.formatMoney(variant.price, moneyFormat);
    }

    if (stickyButton && stickyButtonText) {
      var available = variant.available;
      stickyButton.disabled = !available;
      stickyButtonText.textContent = available ? 'Add to cart' : 'Sold out';
    }
  });

  // --- Fallback: sync sticky variant select back to real form ---
  if (stickyVariantInput && stickyVariantInput.tagName === 'SELECT') {
    stickyVariantInput.addEventListener('change', function () {
      var realVariantInput = document.querySelector('.product-variant-id');
      if (realVariantInput) {
        realVariantInput.value = this.value;
        realVariantInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });
  }

  // --- Add to cart: trigger Dawn's own real button, show loading state ---
  // --- until the cart drawer actually opens                            ---
  var loadingResetTimeout = null;

  function setLoading(isLoading) {
    if (!stickyButton) return;
    stickyButton.classList.toggle('is-loading', isLoading);
    stickyButton.disabled = isLoading;
  }

  if (stickyButton) {
    stickyButton.addEventListener('click', function () {
      if (!mainAtcForm) return;

      var realVariantInput = mainAtcForm.querySelector('.product-variant-id');
      if (realVariantInput && stickyVariantInput) {
        realVariantInput.value = stickyVariantInput.value;
      }

      setLoading(true);

      // Safety net: if the drawer never opens (error, network issue),
      // don't leave the button stuck spinning forever
      loadingResetTimeout = setTimeout(function () {
        setLoading(false);
      }, 8000);

      if (mainButton) {
        mainButton.click();
      }
    });
  }

  // --- Hide sticky bar + clear loading state once the cart drawer opens ---
  var cartDrawerEl = document.querySelector('cart-drawer');
  if (cartDrawerEl) {
    var drawerObserver = new MutationObserver(function () {
      var isOpen =
        cartDrawerEl.classList.contains('active') ||
        cartDrawerEl.hasAttribute('open') ||
        cartDrawerEl.classList.contains('drawer--is-open');

      if (isOpen) {
        stickyBar.classList.remove('is-visible');
        stickyBar.style.display = 'none';

        if (loadingResetTimeout) {
          clearTimeout(loadingResetTimeout);
          loadingResetTimeout = null;
        }
        setLoading(false);
      } else {
        stickyBar.style.display = '';
      }
    });

    drawerObserver.observe(cartDrawerEl, {
      attributes: true,
      attributeFilter: ['class', 'open']
    });
  }
})();